<template>
  <div>
    <b-alert variant="info" :show="!!message_maintenance">
      <div class="container">
        <p class="mb-0 text-center">{{ message_maintenance }}</p>
      </div>
    </b-alert>
    <b-navbar toggleable="lg" type="light" :class="['tipa-header', { fixed: fixedHeader }, { 'has-background': isntHome }]" ref="tipaNavbar">
      <div class="container">
        <!-- <div class="d-flex justify-content-between"> -->
          <b-navbar-brand to="/" class="logo-container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 239.3 67.89" fill="white"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M70.94,12.16,65.39,6.62a6.29,6.29,0,0,0-.47-.43c-.24-.27-.48-.53-.73-.77C60.65,1.87,55.76,0,50.05,0c-7.54,0-15.93,3.31-23.3,9.05a5.08,5.08,0,0,0-10,.14l-.88,5.3a7.66,7.66,0,0,1-6.31,6.32l-5.3.87a5.09,5.09,0,0,0,0,10l5.3.87.28.07c-2.71,9-1.54,17.51,4,23.08l.48.45c.1.12.2.24.31.35l6,6c3.53,3.53,8.4,5.4,14.1,5.4h0a30.71,30.71,0,0,0,8.13-1.17,41.93,41.93,0,0,0,11.26-5.1A52.56,52.56,0,0,0,63,54.52a51.59,51.59,0,0,0,7.1-8.86,42.21,42.21,0,0,0,5.1-11.26C77.65,25.44,76.11,17.33,70.94,12.16ZM4.87,28a1.35,1.35,0,0,1,0-2.66l5.29-.87a11.26,11.26,0,0,0,4.11-1.57,11.29,11.29,0,0,0,5.05-6.85,10,10,0,0,0,.25-1l.87-5.3a1.34,1.34,0,0,1,2.65,0l.34,2.07.25,1.49L24,15.1c0,.16.08.31.12.47a10.76,10.76,0,0,0,.64,2A11.31,11.31,0,0,0,29,22.76h0a11.27,11.27,0,0,0,3.84,1.61c.18,0,.36.1.55.13l5.29.87a1.35,1.35,0,0,1,0,2.66l-1.87.3-3.42.57A11.55,11.55,0,0,0,24,38.3L23.18,43l-.07.47,0,.1a1.33,1.33,0,0,1-2.59.18,1,1,0,0,1-.06-.18l-.87-5.3a11.39,11.39,0,0,0-4-6.89,10.13,10.13,0,0,0-1.52-1.07,11.09,11.09,0,0,0-1.77-.85,10.16,10.16,0,0,0-1.19-.36c-.31-.08-.62-.18-.94-.23Zm58.76-1.7a37.39,37.39,0,0,1-4.5,9.92,47.31,47.31,0,0,1-6.44,8,46.75,46.75,0,0,1-8,6.43,37.43,37.43,0,0,1-9.92,4.51,25.85,25.85,0,0,1-6.77,1,16.65,16.65,0,0,1-6.57-1.25A13,13,0,0,1,18,52.79c-.21-.19-.43-.37-.63-.58-3.94-3.93-4.82-10.11-3.1-16.82a7.63,7.63,0,0,1,1.57,3.52l.88,5.3a5,5,0,0,0,2.65,3.66,5,5,0,0,0,6.51-1.57,4.72,4.72,0,0,0,.49-.88c3,1.1,7.15.46,11.39-1.66a32.68,32.68,0,0,0,8.33-6.09,32.68,32.68,0,0,0,6.09-8.33c2.79-5.59,3-11,.1-13.93a7.44,7.44,0,0,0-4.42-2,12.38,12.38,0,0,0-1.51-.09c-4.36,0-9.79,2.46-14.67,6.75a7.63,7.63,0,0,1-4-5.33C34.92,8.42,43.15,5,50.05,5A14.64,14.64,0,0,1,60.67,8.94c.3.31.58.62.84.94A12.7,12.7,0,0,1,63.37,13C65,16.73,65,21.4,63.63,26.33ZM25,59.69a22.8,22.8,0,0,0,3,.22,30.39,30.39,0,0,0,9.76-1.74l3.75,3.74C35.06,63.7,29.06,63.07,25,59.69Zm26.44-2.28-4-4a51.16,51.16,0,0,0,7.94-6.49l4.1,4.1A47.23,47.23,0,0,1,51.44,57.41ZM65.86,43l-4-4a43.18,43.18,0,0,0,4.77-9.64l3.78,3.78A37,37,0,0,1,65.86,43Z"/><path class="cls-1" d="M110.28,36.6l.65,6.91c-.61,1-4,3.05-8.85,3.05-8.92,0-10.69-6-10.69-10.49V32.45a1.08,1.08,0,0,0-1.08-1.08H88.78l-.28-7h0a5,5,0,0,0,3.34-4.42c0-.47,0-.79,0-.89l8.56-2.09c0,.28,0,3-.12,6,8.64.12,10.61.93,10.61.93L110.6,31l-10.36-.08v5.26c0,2.05,1.32,2.53,3.33,2.53A11.49,11.49,0,0,0,110.28,36.6Z"/><path class="cls-1" d="M144.29,22.29a8.51,8.51,0,0,0-7,3.28,1.45,1.45,0,0,1-2.59-.79c-.11-1.49-.22-2.14-.22-2.49L126,23.9c0,.48.16,4.78.16,10.48,0,5.29-.06,11.28-.1,15.28a4.49,4.49,0,0,0,4.49,4.54h.14a4.5,4.5,0,0,0,4.49-4.55c0-1.78,0-3.95-.07-6.27a.73.73,0,0,1,1.3-.47,9.46,9.46,0,0,0,7.32,3.65c7.39,0,10.36-5.83,10.36-11.89C154.05,28.4,151.76,22.29,144.29,22.29ZM139.94,39.1h-4.71V34.38a4.71,4.71,0,1,1,4.71,4.72Z"/><circle class="cls-1" cx="118.32" cy="18.43" r="4.74"/><path class="cls-1" d="M122.91,24.88a7.89,7.89,0,0,1-9.17,0c0,.65.2,3.12.2,8.78,0,3.42,0,6-.07,7.93a4.5,4.5,0,1,0,9,0c0-1.92-.07-4.51-.07-7.93C122.79,28,122.9,25.53,122.91,24.88Z"/><circle class="cls-1" cx="234.56" cy="18.43" r="4.74"/><path class="cls-1" d="M239.14,24.88a7.87,7.87,0,0,1-9.16,0c0,.65.2,3.12.2,8.78,0,3.42,0,6-.07,7.93a4.49,4.49,0,1,0,9,0c0-1.92-.07-4.51-.07-7.93C239,28,239.14,25.53,239.14,24.88Z"/><circle class="cls-1" cx="192.85" cy="41.82" r="4.74"/><path class="cls-1" d="M184.84,34.46c0-8.68.12-11.61.12-12.17l-8.64,1.2v0a1.45,1.45,0,0,1-2.47,1,9.57,9.57,0,0,0-6.65-2.2c-6.55,0-10.17,4.5-10.17,11.89,0,7.08,3.62,12.38,10.17,12.38a8.56,8.56,0,0,0,7.55-4.26.73.73,0,0,1,1.35.34c.14,2.55.3,3.46.3,3.92L185,45C185,44.47,184.84,40.17,184.84,34.46Zm-9.11-.08A4.71,4.71,0,1,1,171,29.67h4.71Z"/><path class="cls-1" d="M226.69,34.46c0-8.68.12-11.61.12-12.17l-8.64,1.2v0a1.45,1.45,0,0,1-2.47,1,9.59,9.59,0,0,0-6.65-2.2c-6.56,0-10.17,4.5-10.17,11.89,0,7.08,3.61,12.38,10.17,12.38a8.53,8.53,0,0,0,7.54-4.26.74.74,0,0,1,1.36.34c.13,2.55.3,3.46.3,3.92l8.6-1.61C226.85,44.47,226.69,40.17,226.69,34.46Zm-9.11-.08a4.72,4.72,0,1,1-4.72-4.71h4.72Z"/></g></g></svg>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <!-- <b-nav-item to="/">
                Home
              </b-nav-item> -->
              <b-nav-item-dropdown text="Como funciona">
                <!-- <b-dropdown-item to="/">Home</b-dropdown-item> -->
                <b-dropdown-item to="/pages/widgets">Recursos</b-dropdown-item>
                <b-dropdown-item to="/pages/tipa_subs">Tipa Subs</b-dropdown-item>
                <b-dropdown-item to="/pages/taxas">Taxas</b-dropdown-item>
                <b-dropdown-item to="/pages/faq">Ajuda</b-dropdown-item>
                <!-- <b-dropdown-item to="/pages/api">API</b-dropdown-item> -->
              </b-nav-item-dropdown>
              <b-nav-item-dropdown text="Para empresas" v-if="false">
                <b-dropdown-item to="/pages/tipa">Podcasts</b-dropdown-item>
                <b-dropdown-item to="/pages/tipa">Marcas</b-dropdown-item>
                <b-dropdown-item to="/pages/tipa">Anuncie</b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown text="Tipa" v-if="false">
                <b-dropdown-item to="/pages/tipa">Sobre a Tipa</b-dropdown-item>
                <!-- <b-dropdown-item to="/blog">Blog</b-dropdown-item> -->
              </b-nav-item-dropdown>
              <b-nav-item-dropdown v-if="false" text="Para quem">
                <b-dropdown-item to="/p/streamer">livestream</b-dropdown-item>
                <b-dropdown-item to="/p/podcast">podcast</b-dropdown-item>
                <b-dropdown-item to="/p/canal">canal</b-dropdown-item>
                <!-- <b-dropdown-item to="#">rádio</b-dropdown-item> -->
                <!-- <b-dropdown-item to="/pages/tipa">Sobre a Tipa</b-dropdown-item> -->
                <!-- <b-dropdown-item to="/blog">Blog</b-dropdown-item> -->
              </b-nav-item-dropdown>

              <!-- <b-nav-item to="/">
                Para empresas
              </b-nav-item> -->
              <!-- &amp; Blog -->
              <!-- <a href="#">Developers</a> -->
              <b-nav-item v-if="!isLoggedIn" to="/login" class="btn-login">
                Entrar
              </b-nav-item>
              <b-nav-item v-else to="/dashboard" class="btn-login">
                Meu Painel
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        <!-- </div> -->
      </div>
    </b-navbar>

    <header-small v-if="false" />

    <!-- name="scale" mode="out-in" -->
    <transition>
      <slot />
    </transition>

    <site-footer></site-footer>
  </div>
</template>

<script>
import UserService from '@/services/user.service'
import HeaderSmall from '@/components/HeaderSmall/index.vue'
import SiteFooter from '@/components/SiteFooter/index.vue'
// import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue'
export default {
  name: 'MarketingLayout',
  metaInfo: {
    bodyAttrs: {
      class: ['marketing-layout']
    }
  },
  components: {
    HeaderSmall,
    SiteFooter
    // LottieAnimation
  },
  computed: {
    currentUser () {
      return this.$store.getters['user/currentUser']
    },
    isLoggedIn () {
      return this.$store.getters['user/loggedIn']
    },
    isntHome () {
      return this.$route.name !== 'PagesHome'
    }
  },
  data () {
    return {
      fixedHeader: false
    }
  },
  methods: {
    async logout () {
      await UserService.logout()
      this.$store.commit('user/logout')
      this.$router.push('/login').catch(() => { })
    },

    onScroll () {
      // this.$refs.tipaNavbar
      this.fixedHeader = (window.scrollY > 50)
    }
  },
  mounted () {
    try {
      window.addEventListener('scroll', this.onScroll)
    } catch (_) { }
  },
  destroyed () {
    try {
      window.removeEventListener('scroll', this.onScroll)
    } catch (_) { }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
}

.tipa-header {
  background: transparent;
  position: fixed;
  width: 100%;
  // height: 40px;
  color: white;
  z-index: 3;
  transition: all .5s;
  padding: 0;

  > .container {
    // padding-top: 2rem;
    padding: 1rem;
    position: relative;

    .logo-container {
      width: 100%;
      height: auto;

      max-width: 120px;
      position: relative;
      top: inherit;
      left: inherit;
      // transform: translateY(5px);
      padding: 0;

      svg {
        transition: all .5s;
      }
    }

    nav {

    }

    a {
      color: white;
      display: inline-block;
      padding: .4rem .8rem;
      transition: all .5s;

    }
    .btn-login a {
      transition: all .5s;
      background: rgba(255, 255, 255, .24);
      border-radius: 25px;
      padding: 0.4rem 1.2rem;
      margin-left: .5rem;
    }
  }

  &.fixed,
  &.has-background {
    background: rgba(255, 255, 255, .8);
    color: #424242;
    // color: #C9C9C9;

    .logo-container {
      opacity: .7;
      transition: all .2s;
      &:hover {
        opacity: 1;

      }

      svg {
        fill: #424242;
        // fill: #C9C9C9;
      }
    }

    a {
      color: #424242;
      // color: #C9C9C9;

    }
    .btn-login a {
      background: rgba(33, 33, 33, .14);
    }
  }
}
</style>

<style lang="scss">
body.marketing-layout {
  .tipa-header {
    // .navbar-nav .dropdown-menu {
    //   color: rgba(255, 255, 255, .8);
    // }
    // &.fixed {
    .navbar-nav .dropdown-menu {
      color: white;
      z-index: 10;
      a.dropdown-item {
        color: white;
      }
      @media screen and (max-width: 600px) {
        background: rgba(255, 255, 255, .8);
        color: black;
        a.dropdown-item {
          color: black;
        }
      }
    }

    .nav-link {
      outline: 0 !important;
      color: white;
    }

    &.has-background,&.fixed {
      .navbar-nav .dropdown-menu {
        background: rgba(255, 255, 255, .8);
        color: black;
        z-index: 10;
        a.dropdown-item {
          color: black;
        }
      }

      .nav-link {
        color: black;
      }
    }
  }
}
</style>
